/* Polsk katalog for locale-investments.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'investments.reviewAndEdit': 'Sprawdź i edytuj',
  'investments.editSourceFact': 'Edytuj informację źródłową',
  'investments.correctedSourceFactHelp': 'Poprawiaj tylko informacje sprawdzone z oryginalnym dokumentem. Zmiana jest rejestrowana wraz z użytkownikiem i czasem.',
  'investments.saveCorrection': 'Zapisz poprawkę',
  'investments.addOptionalComment': 'Dodaj komentarz (opcjonalnie)',
  'investments.reviewNoteOptional': 'Komentarz do kontroli (opcjonalnie)',
  'investments.openingReconciliation': 'BO inwestycji a księga główna',
  'investments.openingReconciliationHelp': 'Wyświetlane inwestycje na otwarcie są porównywane z kontami inwestycji w bilansie otwarcia. Różnice pieniężne do {{tolerance}} włącznie są akceptowane.',
  'investments.openingRegisterValue': 'Wyświetlane inwestycje',
  'investments.openingLedgerValue': 'BO księgi głównej',
  'investments.total': 'Suma',
  'investments.openingLedgerMismatch': 'Inwestycje na otwarcie i księga główna nie są uzgodnione.',
  'investments.details': 'Szczegóły',
  'investments.eventDetails': 'Szczegóły zdarzenia',
  'investments.holdingDetails': 'Szczegóły pozycji',
  'investments.amount': 'Kwota',
  'investments.openingRepairTaxReason': 'Ujęcie podatkowe trzeba potwierdzić na podstawie zestawienia rocznego lub innej dokumentacji.',
  'investments.openingRepairReason': 'Stan początkowy udokumentowany i sprawdzony przed sprzedażą.',
  'investments.authenticationRequired': 'Zaloguj się, aby korzystać z rejestru inwestycji.',
  'investments.businessInvalid': 'Wybierz prawidłową firmę.',
  'investments.businessNotFound': 'Nie znaleziono danych księgowych firmy.',
  'investments.operationFailed': 'Nie udało się wykonać operacji. Spróbuj ponownie.',
  'investments.measurement': 'Udokumentowana zasada wyceny',
  'investments.cost': 'Cena nabycia z odpisem aktualizującym',
  'investments.fair_value': 'Wartość godziwa (warunki udokumentowane)',
  'investments.measurementReview': 'Wybierz i udokumentuj zasadę wyceny. Wartość godziwa wymaga kwalifikujących się aktywów obrotowych.',
  'investments.valueAboveCost': 'Przy wybranej zasadzie wartość bilansowa nie może przekraczać ceny nabycia.',
  'investments.duplicateInstrument': 'Ta klasa inwestycji jest już zarejestrowana. Używaj tej samej inwestycji we wszystkich rachunkach maklerskich.',
  'investments.receiptAlreadyBooked': 'Dowód księgowy został już zaksięgowany. Do dokumentacji obejmującej wiele zdarzeń używaj dokumentów spółki.',
  'investments.bankMatched': 'Powiązano z bankiem',
  'investments.matchBank': 'Uzgodnij z linią bankową',
  'investments.bankMatchInvalid': 'Nie można powiązać linii bankowej. Odśwież i sprawdź datę, kwotę i konto.',
  'investments.bankUnmatchRequired': 'Otwórz powiązanie w uzgodnieniu bankowym, zanim wycofasz zdarzenie.',
  'investments.acquisitionDate': 'Pierwotna data nabycia (FIFO)',
  'nav.investeringer': 'Inwestycje',
  'route.investeringer': 'Inwestycje',
  'navhelp.investeringer': 'Akcje, fundusze i powiązana księgowość.',
  'investments.title': 'Inwestycje',
  'investments.subtitle': 'Akcje, fundusze i udokumentowane zdarzenia',
  'investments.newInstrument': 'Nowa inwestycja',
  'investments.newEvent': 'Nowe zdarzenie',
  'investments.name': 'Nazwa',
  'investments.kind': 'Typ',
  'investments.share': 'Akcja',
  'investments.fund': 'Fundusz',
  'investments.isin': 'ISIN (opcjonalnie)',
  'investments.issuerCountry': 'Kraj emitenta (kod kraju)',
  'investments.accountCode': 'Konto bilansowe',
  'investments.valuationAccountCode': 'Konto korekty wartości',
  'investments.taxTreatment': 'Ujęcie podatkowe',
  'investments.accountSource.saved_instrument': 'Kontynuuje konto już zapisane dla tej inwestycji.',
  'investments.accountSource.opening_balance': 'Zaproponowano na podstawie jednoznacznej nazwy i salda w bilansie otwarcia.',
  'investments.accountSource.manual': 'Konto wybrano ręcznie i będzie dalej używane dla tej inwestycji.',
  'investments.accountSource.default': 'Nie znaleziono jednoznacznego konta historycznego. Zaproponowano 1810 bez blokowania księgowania.',
  'investments.review': 'Wymaga wyjaśnienia',
  'investments.exempt': 'W ramach metody zwolnienia',
  'investments.taxable': 'W pełni opodatkowane',
  'investments.mixed': 'Mieszana część akcyjna i odsetkowa',
  'investments.taxReason': 'Podstawa ujęcia podatkowego',
  'investments.instrumentId': 'Inwestycja',
  'investments.choose': 'Wybierz',
  'investments.instrumentScope': 'Rejestracja dotyczy NOK i NRS 8. Potwierdź kraj, ramy prawne i kategorię podatkową na podstawie dokumentacji. Fundusze mieszane wymagają osobnego wyjaśnienia.',
  'investments.date': 'Data księgowania',
  'investments.reference': 'Unikalna referencja transakcji',
  'investments.quantity': 'Liczba',
  'investments.provider': 'Dostawca / rachunek maklerski',
  'investments.targetProvider': 'Nowy rachunek maklerski',
  'investments.lotId': 'Podatkowa partia nabycia',
  'investments.gross': 'Przychód brutto / wypłata',
  'investments.fees': 'Koszty / prowizja',
  'investments.bookCost': 'Księgowa cena nabycia',
  'investments.bookValue': 'Wartość bilansowa',
  'investments.taxCost': 'Podatkowa cena nabycia',
  'investments.settlementAccount': 'Konto rozliczeniowe',
  'investments.evidence': 'Dokumentacja',
  'investments.taxConfirmed': 'Sprawdziłem ujęcie podatkowe dla tego zdarzenia i roku podatkowego.',
  'investments.opening': 'Stan początkowy',
  'investments.purchase': 'Zakup',
  'investments.sale': 'Sprzedaż',
  'investments.dividend': 'Dywidenda / wypłata',
  'investments.annual_income': 'Roczna informacja o odsetkach',
  'investments.annualIncomeHelp': 'Używaj tylko wtedy, gdy dostawca dokumentuje, że odsetki w zestawieniu rocznym są informacją sprawozdawczą bez osobnej płatności gotówkowej, nowych jednostek ani zmiany księgowej lub podatkowej ceny nabycia. Nie jest tworzone żadne księgowanie.',
  'investments.liquidation': 'Rozliczenie likwidacyjne',
  'investments.fee_redemption': 'Umorzenie na pokrycie opłaty za fundusz',
  'investments.transfer': 'Przeniesienie rachunku maklerskiego',
  'investments.split': 'Split lub zmiana klasy jednostek',
  'investments.demerger': 'Podział spółki',
  'investments.cost_basis_adjustment': 'Korekta ceny nabycia',
  'investments.valuation': 'Wycena',
  'investments.targetInstrumentId': 'Inwestycja przejmująca',
  'investments.bookCostAdjustment': 'Zmiana księgowej ceny nabycia',
  'investments.bookValueAdjustment': 'Zmiana wartości bilansowej',
  'investments.taxCostAdjustment': 'Zmiana podatkowej ceny nabycia',
  'investments.adjustmentAccount': 'Konto przeciwstawne',
  'investments.demergerHelp': 'Podaj udokumentowaną liczbę i ceny nabycia przenoszone z tej inwestycji do inwestycji przejmującej. Zdarzenie nie powoduje zysku, straty ani ruchu bankowego.',
  'investments.costBasisAdjustmentHelp': 'Używaj kwot korekty ze znakiem. Zmiana wartości bilansowej wymaga udokumentowanego konta przeciwstawnego.',
  'investments.yearEndAssessment': 'Ocena na koniec roku',
  'investments.yearEndAssessmentHelp': 'Potwierdź na podstawie dokumentacji, że pozycja jest nadal wyceniana według ceny nabycia i nie ma podstaw do odpisu aktualizującego.',
  'investments.saveYearEndAssessment': 'Zapisz ocenę',
  'investments.transferHelp': 'Przenieś całą partię nabycia. Historyczna cena nabycia zostaje zachowana i nie jest tworzone żadne księgowanie bankowe.',
  'investments.openingHelp': 'Zarejestruj pozycję, która jest już ujęta w bilansie otwarcia. Nie tworzy to nowego księgowania. Uzgodnij z księgą główną.',
  'investments.dividendTaxFraction': 'Opodatkowana część wypłaty',
  'investments.dividendThree': '3 % – zwykła metoda zwolnienia',
  'investments.dividendZero': '0 % – udokumentowany wyjątek',
  'investments.valuationTreatment': 'Rodzaj różnicy podatkowej',
  'investments.temporary': 'Różnica przejściowa',
  'investments.permanent': 'Różnica trwała',
  'investments.saveDraft': 'Zapisz',
  'investments.uploadFirst': 'Wgraj dokumentację przez Dokumentację lub Dokumenty w ustawieniach.',
  'investments.loading': 'Pobieranie rejestru inwestycji …',
  'investments.unavailable': 'Nie udało się pobrać rejestru.',
  'investments.supportScope': 'Norweskie AS, NOK i NRS 8, lata podatkowe 2024–2026. Niewyjaśnione lub złożone ujęcie podatkowe wymaga przeglądu.',
  'investments.holdings': 'Stan posiadania',
  'investments.events': 'Zdarzenia',
  'investments.closing': 'Uzgodnienie i zamknięcie roku',
  'investments.eventsHelp': 'Zakupy, sprzedaże i inne udokumentowane zmiany w rejestrze inwestycji.',
  'investments.noEvents': 'Brak zdarzeń w okresie',
  'investments.noEventsHelp': 'Nowe zakupy i inne zmiany pojawią się tutaj po zarejestrowaniu lub pobraniu ze skrzynki odbiorczej inwestycji.',
  'investments.ai': 'Przetwarzanie AI',
  'investments.aiBatchTitle': 'Przetwarzanie inwestycji przez AI',
  'investments.aiBatchIntro': 'Wgraj razem całą dokumentację inwestycji za rok. Plumme odczytuje dokumenty, oddziela zdarzenia od materiałów kontrolnych i zbiera to, co wymaga sprawdzenia.',
  'investments.aiBatchLockedHelp': 'Masowe wgrywanie i zbiorcze przetwarzanie AI wymagają aktywnej subskrypcji Plumme. Skrzynka odbiorcza i ręczna rejestracja pozostają dostępne.',
  'investments.aiBatchActivate': 'Zobacz subskrypcję',
  'investments.aiBatchUpload': 'Prześlij wszystkie dokumenty',
  'investments.aiBatchSourceOpening': 'BO i poprzednie zestawienie roczne',
  'investments.aiBatchSourceTransactions': 'Kupno, sprzedaż, podziały i zmiany ceny nabycia',
  'investments.aiBatchSourceBank': 'Wyciągi bankowe i opłaty',
  'investments.aiBatchSourceAnnual': 'Zestawienie roczne lub raport grudniowy',
  'investments.aiBatchSummary': 'Status przetwarzania AI',
  'investments.aiBatchDocuments': 'Odczytane dokumenty',
  'investments.aiBatchPrepared': 'Przygotowano',
  'investments.aiBatchEvidence': 'Podstawa kontroli',
  'investments.aiBatchExceptions': 'Wyjątki',
  'investments.aiBatchProposalTitle': 'Zbiorcza podstawa robocza',
  'investments.aiBatchProposalHelp': 'Wszystkie odczytane pozycje są wyświetlane razem. Użyj ołówka, aby poprawić dane źródłowe. Nic nie zostanie zaksięgowane przed zatwierdzeniem propozycji.',
  'investments.aiBatchEmpty': 'Prześlij dokumenty, aby zbudować zbiorczą podstawę roboczą.',
  'investments.aiBatchOpenArchive': 'Otwórz archiwum dokumentów',
  'investments.aiBatchApprovalLater': 'Zbiorcza propozycja księgowania i końcowe zatwierdzenie zostaną przygotowane w następnym kroku.',
  'investments.aiBatchPostingTitle': 'Zbiorczy pakiet księgowań',
  'investments.aiBatchPostingHelp': 'To jest faktycznie proponowane księgowanie. Dane źródłowe można edytować; FIFO, zyski/straty i księgowania są przeliczane na nowo.',
  'investments.aiBatchPreparing': 'Tworzenie pakietu księgowań …',
  'investments.aiBatchNoDrafts': 'Brak nieprzetworzonych szkiców zdarzeń gotowych do zaksięgowania.',
  'investments.aiBatchRefreshPackage': 'Przelicz ponownie',
  'investments.aiBatchFinalApprove': 'Zatwierdź cały pakiet inwestycji',
  'investments.debit': 'Winien',
  'investments.credit': 'Ma',
  'investments.fifo': 'Partie FIFO',
  'investments.yearEndBankMissing': 'Brak powiązania z bankiem.',
  'investments.yearEndBankAmbiguous': 'Powiązanie z bankiem jest niejednoznaczne.',
  'investments.yearEndBankMatchFailed': 'Nie udało się zapisać powiązania z bankiem.',
  'investments.missing_tax_realization_confirmation': 'Brak potwierdzenia podatkowej realizacji.',
  'investments.missingTaxRealizationOverrideHelp': 'Raport grudniowy nie dokumentuje podatkowych realizacji. Prześlij zestawienie roczne/realizacji albo udokumentuj, dlaczego pomijasz tę kontrolę.',
  'investments.overrideReason': 'Uzasadnienie i skutki',
  'investments.recordOverride': 'Zarejestruj identyfikowalne nadpisanie',
  'investments.aiBatchStatus.prepared': 'Gotowe do propozycji',
  'investments.aiBatchStatus.draft': 'Szkic',
  'investments.aiBatchStatus.posted': 'Zaksięgowano',
  'investments.aiBatchStatus.evidence': 'Podstawa kontroli',
  'investments.aiBatchStatus.exception': 'Wymaga wyjaśnienia',
  'investments.investmentAiBatchSubscriptionRequired': 'Zbiorcze przetwarzanie AI wymaga aktywnej subskrypcji.',
  'investments.refresh': 'Odśwież',
  'investments.edit': 'Edytuj',
  'investments.empty': 'Zarejestruj inwestycję i dodaj stan początkowy lub zakup.',
  'investments.status': 'Status',
  'investments.actions': 'Działania',
  'investments.draft': 'Szkic',
  'investments.posted': 'Zatwierdzono',
  'investments.reversed': 'Wycofano',
  'investments.preview': 'Zobacz propozycję księgowania',
  'investments.discard': 'Usuń szkic',
  'investments.reverse': 'Wycofaj zdarzenie',
  'investments.reconciliation': 'Uzgodnienie z księgą główną',
  'investments.ledgerValue': 'Księga główna',
  'investments.difference': 'Rozbieżność',
  'investments.closingHelp': 'Zarejestruj udokumentowaną wycenę na 31 grudnia dla każdej pozycji. Rozbieżności i otwarte szkice muszą zostać rozwiązane, zanim różnice podatkowe zostaną przeniesione do zamknięcia roku. Stan jest przenoszony na następny rok.',
  'investments.taxDifferences': 'Różnice podatkowe',
  'investments.note': 'Podstawa noty o papierach wartościowych',
  'investments.reviewNote': 'Komentarz do kontroli',
  'investments.reviewClosing': 'Zatwierdź uzgodnienie i przenieś różnice podatkowe',
  'investments.closingReviewed': 'Podstawa inwestycji została sprawdzona i przeniesiona.',
  'investments.proposal': 'Propozycja księgowania',
  'investments.noJournal': 'Aktualizuje rejestr bez nowego księgowania w księdze głównej.',
  'investments.bookProfit': 'Wynik bilansowy',
  'investments.taxProfit': 'Wynik podatkowy',
  'investments.approve': 'Zatwierdź i zaksięguj',
  'investments.existingPostingTitle': 'Już zaksięgowano',
  'investments.existingPostingHelp': 'To księgowanie w księdze głównej uzgadnia się łącznie ze zdarzeniami z tej daty. Powiąż zdarzenia bez ponownego księgowania.',
  'investments.existingPostingNote': 'Notatka kontrolna',
  'investments.linkExistingPosting': 'Powiąż z {{voucher}} (zdarzenia: {{count}})',
  'investments.reverseHelp': 'Najpierw trzeba wycofać zdarzenia zatwierdzone później. Wycofanie jest księgowane w pierwotnym otwartym okresie i pozostaje w historii.',
  'investments.confirmReverse': 'Potwierdź wycofanie',
  'investments.evidenceRequired': 'Brak dokumentacji i unikalnego odniesienia.',
  'investments.quantityRequired': 'Podaj dodatnią liczbę.',
  'investments.lotQuantityInvalid': 'Liczba przekracza stan posiadania. Podatkowa cena nabycia jest obliczana metodą FIFO.',
  'investments.feeMustMatchRedemption': 'Opłata i kwota umorzenia muszą być równe.',
  'investments.dividendFeesReview': 'Wypłaty z kosztami wymagają odrębnego rozpatrzenia.',
  'investments.fullLotTransferRequired': 'Wybierz całą partię nabycia i nowy rachunek papierów wartościowych.',
  'investments.positionRequired': 'Najpierw zarejestruj stan posiadania.',
  'investments.valuationTaxReview': 'Trzeba wyjaśnić podatkowe ujęcie wyceny.',
  'investments.annualIncomeScopeReview': 'Roczne informacje o odsetkach są obsługiwane tylko dla udokumentowanych, w pełni opodatkowanych funduszy.',
  'investments.annualIncomeDateRequired': 'Roczne informacje o odsetkach muszą mieć datę 31 grudnia.',
  'investments.taxReviewRequired': 'Sprawdź i udokumentuj ujęcie podatkowe.',
  'investments.bankAccountRequired': 'Wybierz aktywny rachunek bankowy.',
  'investments.demergerTargetRequired': 'Wybierz inną inwestycję przejmującą dla podziału.',
  'investments.demergerBasisInvalid': 'Przenoszone ceny nabycia nie mogą przekraczać podstawy stanu posiadania.',
  'investments.demergerMeasurementUnsupported': 'Podział jest obecnie obsługiwany tylko dla inwestycji wycenianych według kosztu.',
  'investments.basisAdjustmentRequired': 'Podaj co najmniej jedną zmianę ceny nabycia.',
  'investments.basisAdjustmentInvalid': 'Zmiana ceny nabycia dałaby ujemną podstawę.',
  'investments.basisAdjustmentMeasurementUnsupported': 'Zmiana ceny nabycia jest obecnie obsługiwana tylko dla inwestycji wycenianych według kosztu.',
  'investments.adjustmentAccountRequired': 'Wybierz konto przeciwstawne, gdy zmienia się wartość bilansowa.',
  'investments.openingYearInvalid': 'Zestawienie roczne może służyć jako BO tylko dla roku raportu lub dla następnego roku, gdy data raportu to 31.12.',
  'investments.unbalanced': 'Propozycja się nie bilansuje.',
  'investments.dateInvalid': 'Wybierz prawidłową datę.',
  'investments.scopeUnsupported': 'Ten proces obsługuje norweskie AS w latach 2024–2026.',
  'investments.amountRequired': 'Brak wymaganej kwoty.',
  'investments.amountInvalid': 'Sprawdź kwotę.',
  'investments.instrumentInvalid': 'Sprawdź rodzaj, konto i zasady inwestycji.',
  'investments.instrumentReviewRequired': 'Udokumentuj podatkowe ujęcie inwestycji.',
  'investments.evidenceNotFound': 'Dokumentacja nie istnieje w tej firmie.',
  'investments.eventInvalid': 'Nieprawidłowe zdarzenie.',
  'investments.dividendFractionInvalid': 'Wybierz udokumentowaną część podlegającą opodatkowaniu.',
  'investments.instrumentHasHistory': 'Inwestycja ma zatwierdzone zdarzenia. Historii nie można zmienić bezpośrednio.',
  'investments.issuerCountryRequired': 'Podaj kraj emitenta.',
  'investments.instrumentNotFound': 'Inwestycja nie istnieje.',
  'investments.eventImmutable': 'Dla zatwierdzonych zdarzeń użyj wycofania.',
  'investments.duplicateEvent': 'Zdarzenie z tym odniesieniem jest już zarejestrowane.',
  'investments.eventNotFound': 'Zdarzenie nie istnieje.',
  'investments.chronologyRequired': 'Zatwierdzaj zdarzenia w kolejności dat.',
  'investments.openingMustPrecedeActivity': 'Stan początkowy musi mieć datę 1 stycznia, przed innymi zdarzeniami.',
  'investments.proposalStale': 'Podstawa się zmieniła. Pobierz nową propozycję.',
  'investments.reverseLatestFirst': 'Najpierw wycofaj ostatnie zatwierdzone zdarzenie.',
  'investments.existingPostingMismatch': 'Istniejące księgowanie nie zgadza się z łącznym rozliczeniem inwestycji.',
  'investments.existingPostingUnlinkRequired': 'Usuń powiązanie z istniejącym księgowaniem w księdze głównej przed wycofaniem zdarzenia.',
  'investments.reasonRequired': 'Wpisz uzasadnienie.',
  'investments.actionInvalid': 'Operacja nie jest obsługiwana.',
  'investments.documentPostedCannotDelete': 'Zaksięgowanego dokumentu inwestycji nie można przenieść do kosza.',
  'investments.documentInUseCannotTrash': 'Dokument jest używany przez szkic inwestycji. Usuń szkic przed przeniesieniem dokumentu do kosza.',
  'investments.sourceReviewedConfirmation': 'Wizualnie sprawdziłem/-am oryginalny dokument pod kątem kwoty, daty, funduszu i liczby.',
  'investments.draftsPending': 'Istnieją nieprzetworzone szkice.',
  'investments.ledgerMismatch': 'Rejestr i księga główna się nie zgadzają.',
  'investments.valuationRequired': 'Brak tegorocznej wyceny dla',
  'investments.holdingQuantityMismatch': 'Udokumentowany stan na koniec roku nie zgadza się z liczbą udziałów w rejestrze dla',
  'investments.closingReviewRequired': 'Przed zamknięciem roku należy sprawdzić dane inwestycji.',
  'investments.taxPackageChanged': 'Różnice podatkowe uległy zmianie. Uzgodnij i przenieś ponownie.',
  'investments.useInvestmentWorkflow': 'Zmień to księgowanie w sekcji Inwestycje.',
});
